import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import BoxPLot from "../../components/reports/BoxPlot";
import CandleStick from "../../components/reports/CandleStick";
import ChordPlot from "../../components/reports/ChordPlot";
import FunnelPlot from "../../components/reports/FunnelPlot";
import HiePlot from "../../components/reports/HiePlot";
import HistogramPlot from "../../components/reports/HistogramPlot";
import PercentBar from "../../components/reports/PercentBar";
import RadBar from "../../components/reports/RadialBar";
import RadarPlot from "../../components/reports/RadorPlot";
import RosePlot from "../../components/reports/RosePlot";
import StackedPlot from "../../components/reports/StackedPlot";
import VennPlot from "../../components/reports/VennPlot";

function Reports() {
  const proHeight = document.body.clientHeight;

  const right = (
    <>
      <Tooltip title={"Help"}>
        <Button className="">
          <QuestionCircleOutlined />
        </Button>
      </Tooltip>
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">Reports</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <Row gutter={24}>
            <Col span={12}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <CandleStick />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <VennPlot />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <RadBar />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <HistogramPlot />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <HiePlot />
                </Card>
              </div>
            </Col>
            <Col span={12}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <BoxPLot />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <PercentBar />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <RosePlot />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <RadarPlot />
                </Card>
              </div>
            </Col>
            <Col span={6}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <ChordPlot />
                </Card>
              </div>
            </Col>
            <Col span={12}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <FunnelPlot />
                </Card>
              </div>
            </Col>
            <Col span={12}>
              <div className="mb-6">
                <Card style={{ borderColor: "#e5e7eb" }}>
                  <StackedPlot />
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </Content>
    </>
  );
}

export default Reports;
